import "./main.scss";
import old_home_revamp from "./old_home_revamp/index";
import localforage from "localforage";
import m from "mithril";
import tac from "./old/tac/tac";
import blockwrapper from "./old/blockwrapper/blockwrapper";
import myform from "./old/prasora-form/prasora-form";
import prasorafileexplorer from "./old/prasora-app/prasora-file-explorer/prasora-file-explorer";
import prasoracustomblock from "./old/prasora-custom-block/prasora-custom-block";
import prasoraHeader from "./old/prasora-app/prasora-header/prasora-header";
import praosracustomcomponent from "./old/prasora-app/prasora-custom-components/prasora-custom-components";
import {FocusManager, ResponsiveManager, TransitionManager, Dialog, Button} from "./old/plugins/construct-ui";
import RunStandardProcesses from "./old/standard-prsaora";
import xApi from "./app/x-api.js";

FocusManager.showFocusOnlyOnTab();
ResponsiveManager.initialize({
	xs: "(max-width: 575.98px)",
	sm: "(min-width: 576px) and (max-width: 767.98px)",
	md: "(min-width: 768px) and (max-width: 991.98px)",
	lg: "(min-width: 992px) and (max-width: 1199.98px)",
	xl: "(min-width: 1200px)",
});
TransitionManager.enable();

old_home_revamp();

Array.prototype.removeIf = function (callback) {
	var i = this.length;
	while (i--) {
		if (callback(this[i], i)) {
			this.splice(i, 1);
		}
	}
};

async function CheckIfNeedToClearAllOldIndexDBData() {
	let lf = localforage.createInstance({name: "OldInstancesCleared"});
	let oldHistory = await lf.getItem("itemsCleared");
	// console.log({oldHistory});
	let dversion = 3;
	if (!oldHistory || oldHistory.v < dversion) {
		window.indexedDB
			.databases()
			.then((r) => {
				for (var i = 0; i < r.length; i++) {
					console.log("clearing database ", i, " : ", r[i].name);
					// window.indexedDB.deleteDatabase(r[i].name);
					let lf = localforage.createInstance({name: r[i].name});
					lf.clear();
				}
			})
			.then(() => {
				console.log("All data cleared.");
				let lf = localforage.createInstance({name: "OldInstancesCleared"});
				lf.setItem("itemsCleared", {v: dversion}).then(() => {
					console.log("saved");
					lf.getItem("itemsCleared").then((oldHistory) => {
						console.log("checking", {oldHistory});
					});
				});
			});
	}
}
CheckIfNeedToClearAllOldIndexDBData();
// PWAProcess();

// let headerDone = false;

(async function () {
	PerformMithrilOperations();
});

function PerformMithrilOperations() {
	RunStandardProcesses();

	// let xapi = xApi("xapiworkflow");
	// xapi("process", {
	// 	inputvalue: "something",
	// }).then((result) => {
	// 	console.log("in main", {result});
	// });

	// if ("serviceWorker" in navigator) {
	// 	navigator.serviceWorker
	// 		.register("/sw.js", {type: "module"})
	// 		.then((reg) => {
	// 			console.log("✅ Service Worker registered with scope:", reg.scope);
	// 		})
	// 		.catch((err) => {
	// 			console.error("❌ Service Worker registration failed:", err);
	// 		});
	// }

	// document.body.addEventListener("click", function (e) {
	// 	console.log({e});
	// 	if (e.target.matches("a[href]")) {
	// 		e.preventDefault();
	// 		var url = e.target.href;
	// 		// Update the UI here
	// 		console.log("link clicked");
	// 		requestAnimationFrame(function () {
	// 			setTimeout(function () {
	// 				window.location.href = url;
	// 			});
	// 		});
	// 	}
	// });

	let headerSelectors = document.querySelectorAll("#PrasoraHeaderPanel:not(.header-updated)");
	headerSelectors.forEach((headerSelector) => {
		let menuSelector = document.querySelectorAll("#PrasoraMenuStructure")[0];
		let menuData = menuSelector.value;

		if (headerSelector) {
			headerSelector.className = "";
			m.mount(headerSelector, {
				view: function () {
					return m(prasoraHeader, {
						header: headerSelector,
						menu: menuData,
					});
				},
			});
		}
	});

	import("./old/prasora-app/prasora-chat/prasora-chat.js").then((prasorachat) => {
		let chatSelector = document.querySelectorAll(".prasora-standard-chat-panel");

		chatSelector.forEach((e) => {
			e.classList.toggle("prasora-standard-chat-panel");

			m.mount(e, {
				view: function () {
					return m(prasorachat.default);
				},
			});
		});
	});

	import("./old/prasora-app/prasora-permissionmgt-block/prasora-permissionmgt-block").then(
		(prasorapermissionmgtblock) => {
			let bodySelector = document.querySelectorAll(".container-fluid.prasora-final-content")[0];
			let standardAdminSelector = document.querySelectorAll(".___prasora-permissionmgt-block___");

			standardAdminSelector.forEach((e) => {
				e.classList.toggle("___prasora-permissionmgt-block___");
				bodySelector.classList.toggle("container-fluid");
				bodySelector.classList.toggle("prasora-final-content");

				m.mount(bodySelector, {
					view: function () {
						return m(prasorapermissionmgtblock.default);
					},
				});
			});
		}
	);

	import("./old/prasora-app/notification-manager/notification-manager").then((notificationmanager) => {
		let classname = "prasora-notification-panel";
		let notificationSelector = document.querySelectorAll(`.${classname}`);

		notificationSelector.forEach((e) => {
			e.classList.toggle(classname);
			m.mount(e, {
				view: function () {
					return m(notificationmanager.default);
				},
			});
		});
	});

	import("./old/prasora-app/prasora-widget/prasora-widget").then((widget) => {
		let standardAdminSelector = document.querySelectorAll(".prasora-widget-template");

		standardAdminSelector.forEach((e) => {
			e.classList.toggle("prasora-widget-template");
			let blockcode = e.getAttribute("blockcode");

			let isAdmin = e.getAttribute("isAdmin") == "True";
			//console.log(isAdmin, !!isAdmin, !isAdmin);

			m.mount(e, {
				view: function () {
					return m(widget.default, {
						blockcode: blockcode,
						isAdmin: isAdmin,
					});
				},
			});
		});
	});

	let prasoracustomblocks = document.querySelectorAll(".prasora-custom-block");

	prasoracustomblocks.forEach((e) => {
		e.classList.toggle("prasora-custom-block");
		let blockcode = e.getAttribute("blockcode");
		let isadmin = e.getAttribute("isAdmin") == "True";

		m.mount(e, {
			view: function () {
				return m(prasoracustomblock, {
					blockcode: blockcode,
					isadmin: isadmin,
				});
			},
		});
	});

	let blockSelector = document.querySelectorAll(".___prasora-ut-block___");

	blockSelector.forEach((e) => {
		let tact = "dummy"; //document.getElementById("___tac___").value;

		let tid = e.getAttribute("tid");
		let blockid = e.getAttribute("blockid");
		let prid = e.getAttribute("prid");
		let expanded = e.getAttribute("expanded");
		let blocktitle = e.getAttribute("blocktitle");
		let groups = e.getAttribute("groups");
		let category = e.getAttribute("category");
		let hiddenFieldID = e.getAttribute("selectionhiddenfield");
		let hiddenFieldColumn = e.getAttribute("selectionfield");
		let selectsingle = e.getAttribute("selectsingle");
		let defaultpagesize = e.getAttribute("defaultpagesize");
		let showasfields = e.getAttribute("showasfields");
		let stripdata = e.getAttribute("stripformat");
		let blockcode = e.getAttribute("blockcode");
		let ac = e.getAttribute("appcode");
		let autojuniorblock = e.getAttribute("AutoJuniorBlock");
		let addbuttonpanelid = e.getAttribute("addbuttonpanelid");

		let fixed_expanded = e.getAttribute("fixed_expanded");
		let fixed_editable = e.getAttribute("fixed_editable");

		let refreshtime = e.getAttribute("refreshtime");
		let cachetime = e.getAttribute("cachetime");

		e.classList.toggle("___prasora-ut-block___");

		let addbuttonid = `__addForAutoJuniorBlock${blockid}__`;
		let addbutton = document.getElementById(addbuttonid);

		const blockComponent = () => {
			// let addjuniorblockdialogshown = false;
			// let submittingAdd = false;
			// function CloseComponent() {
			// 	addjuniorblockdialogshown = false;
			// }
			return {
				view: function () {
					if (blockcode == "99") {
						return m(prasorafileexplorer, {
							tid: tid,
							prid: prid,
							blockcode: blockcode,
							tact: tact,
							blocktitle: blocktitle,
						});
					}
					if (blockcode >= "200" && blockcode != "999") {
						return m(praosracustomcomponent, {
							tid,
							prid,
							blockcode,
							tact,
							appcode: ac,
							blocktitle,
							blockid,
						});
					} else {
						return [
							m(blockwrapper, {
								key: tid,
								tid: tid,
								category: category,
								prid: prid,
								blockcode: blockcode,
								appcode: ac,
								blocktitle:
									groups == "prasora" || autojuniorblock
										? blocktitle
										: `${blocktitle} | ${groups ? groups.replace(/ /g, "_") : ""}`,
								expanded: expanded,
								tact: tact,
								showasfields,
								stripdata,
								groups: groups,
								defaultpagesize: defaultpagesize,
								hiddenFieldID: hiddenFieldID,
								hiddenFieldColumn: hiddenFieldColumn,
								fixed_expanded,
								fixed_editable,
								selectsingle,
								autojuniorblock,
								refreshtime,
								cachetime,
							}),
						];
					}
				},
			};
		};

		// console.log({autojuniorblock, addbutton, addbuttonid});

		if (autojuniorblock) {
			if (addbutton) {
				// let panel = document.getElementById(addbutton.getAttribute("buttonpanelid"));
				addbutton.style = "display: none;";

				const addButtonComponent = () => {
					let addjuniorblockdialogshown = false;
					let submittingAdd = false;
					function CloseComponent() {
						addjuniorblockdialogshown = false;
					}
					return {
						view: function () {
							return m(
								".auto-junior-block-buttons",
								m(Dialog, {
									class: "full-width",
									basic: true,
									closeOnEscapeKey: true,
									closeOnOutsideClick: true,
									content: m(blockwrapper, {
										tid: tid,
										category: category,
										prid: prid,
										blockcode: blockcode,
										appcode: ac,
										expanded: true,
										tact: tact,
										groups: addbutton.getAttribute("groups") || "new",
										defaultpagesize: defaultpagesize,
										hiddenFieldID: addbutton.getAttribute("updatefieldid"),
										hiddenFieldColumn: addbutton.getAttribute("selectionfield"),
										fixed_expanded: true,
										fixed_editable: true,
										selectsingle,
									}),
									hasBackdrop: true,
									isOpen: addjuniorblockdialogshown,
									inline: false,
									onClose: CloseComponent,
									title: "Please Select",
									transitionDuration: 200,
									footer: m(`.cui-align-right`, [
										m(Button, {
											intent: undefined,
											label: "Cancel",
											onclick: CloseComponent,
										}),
										m(Button, {
											intent: "primary",
											label: "Add Selected",
											class: `dependency-hidden dependency-on-block-${blockid}a`,
											"dependency-hidden-fields": `selectedRecords__${blockid}`,
											loading: submittingAdd,
											onclick: () => {
												submittingAdd = true;
												// eslint-disable-next-line no-undef
												__doPostBack(addbuttonid, "");
											},
										}),
									]),
								}),
								m(
									"button",
									{
										type: "button",
										class: addbutton?.className,
										onclick: () => {
											addjuniorblockdialogshown = true;
										},
									},
									addbutton?.value
								)
								//m(askbarcomp),
							);
						},
					};
				};

				let buttonPanel = document.getElementById(addbuttonpanelid);
				// console.log({addbuttonpanelid, buttonPanel, addButtonComponent});
				m.mount(buttonPanel, addButtonComponent);
			}
		}

		m.mount(e, blockComponent);
	});

	let formSelector = document.querySelectorAll(".___prasora-nr-block___");

	formSelector.forEach((e) => {
		let node = e.getAttribute("node");
		let rid = e.getAttribute("rid");
		let formid = e.getAttribute("formid");
		let prefields = e.getAttribute("prefields");
		let preparents = e.getAttribute("preparents");
		let isadmin = e.getAttribute("isadmin");

		e.classList.toggle("___prasora-nr-block___");

		m.mount(e, {
			view: function () {
				return m(myform, {
					node,
					rid,
					formid,
					prefields,
					preparents,
					isadmin,
				});
			},
		});
	});

	let tacSelector = document.querySelectorAll(".___prasora-activity-block-wrapper___");

	tacSelector.forEach((e) => {
		e.classList.toggle("___prasora-activity-block-wrapper___");

		m.mount(e, {
			view: function () {
				return m(tac);
			},
		});
	});

	import("./old/prasora-app/block-designer/block-designer").then((blockDesigner) => {
		let pdSelector = document.querySelectorAll(".___page-design-block___");

		pdSelector.forEach((e) => {
			e.classList.toggle("___page-design-block___");
			let id = e.getAttribute("displayid");
			m.mount(e, {
				view: function () {
					return m(blockDesigner.default, {
						id: id,
					});
				},
			});
		});
	});

	import("./old/molecule/solvent/solvent.js").then((pagedesign) => {
		let pageSelector = document.querySelectorAll(".____display-page-structure____");

		// console.log({pageSelector});
		pageSelector.forEach((e) => {
			e.classList.toggle("____display-page-structure____");
			let did = e.getAttribute("did");
			let rid = e.getAttribute("rid");
			let layoutplan = e.getAttribute("layoutplan");

			m.mount(e, {
				view: function () {
					return m(pagedesign.default, {
						did: did,
						rid: rid,
						layoutplan: layoutplan,
					});
				},
			});
		});
	});

	import("./old/prasora-app/prasora-excel-template/prasora-excel-template").then((excelTemplate) => {
		let excelTempSelector = document.querySelectorAll(".prasora-excel-template");

		excelTempSelector.forEach((e) => {
			let template = e.getAttribute("template");
			e.classList.toggle("prasora-excel-template");
			e.removeAttribute("template");

			m.mount(e, {
				view: function () {
					return m(excelTemplate.default, {
						template: template,
					});
				},
			});
		});
	});

	RunOthers();
}

function HighlightSlowestBlock() {
	let blocks = [...document.querySelectorAll(".MyLabelStandardWidth.MyLabel.Hidden.PanelDuration")];
	let maxDuration = blocks.reduce((p, n) => {
		if (n.innerHTML.includes("Duration: ") && n.innerHTML.includes(" [")) {
			{
				var arr = parseFloat(n.innerHTML.split("Duration: ")[1].split(" [")[0]);

				if (arr > p) return arr;
				else return p;
			}
		}
	}, 0);

	for (let i = 0; i < blocks.length; i++) {
		const n = blocks[i];
		if (n.innerHTML.includes("Duration: ") && n.innerHTML.includes(" [")) {
			var arr = parseFloat(n.innerHTML.split("Duration: ")[1].split(" [")[0]);
			if (arr == maxDuration) {
				blocks[i].classList.add("Longest");
			}
		}
	}
}

document.addEventListener("PerformDocumentReadyActivities", function () {
	// console.log("Event: PerformDocumentReadyActivities");
	PerformMithrilOperations();
});

HighlightSlowestBlock();

function RunOthers() {
	import("./app/block-manager/index.js").then((app) => {
		app.default();
	});

	import("./old/prasora-app/standard-admin/standard-admin").then((standardAdmin) => {
		standardAdmin.default();
	});

	import("./old/special-block/special-block").then((prasora_special_block) => {
		prasora_special_block.default();
	});

	import("./old/raw-block/raw-block").then((LoadRawBlock) => {
		LoadRawBlock.default();
	});

	import("./old/special-long-list-dropdown/special-long-list-dropdown.js").then((mod) => {
		mod.default();
	});

	import("./old/special-long-list-dropdown/special-long-list-dropdown.js").then((mod) => {
		mod.default();
	});

	import("./old/report-organization-manager/report-organization-manager.js").then((mod) => {
		mod.default();
	});

	import("./old/special-query/special-query.js").then((mod) => {
		mod.default();
	});

	import("./old/summary-block/summary-block.js").then((mod) => {
		mod.default();
	});

	import("./old/customnodemap/customnodemap.js").then((mod) => {
		mod.default();
	});

	import("./workflow/designer/workflow-designer").then((mod) => {
		mod.default();
	});

	// import("./workflow/player/workflow-player").then((mod) => {
	// 	mod.default();
	// });

	// import("./app/app").then((app) => {
	// 	app.default();
	// });

	import("./old/support-tickets/support-tickets.js").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	// import("./app/display-components/json-editor-button/json-editor-button.js").then((app) => {
	// 	app.default();
	// });

	import("./report-list/report-list").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	import("./node-list/node-list").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	import("./client/index").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	import("./supergrid/supergrid").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	import("./app/form/index").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	import("./app/quickblocks/index").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});
	import("./app/quickquery/index").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	import("./app/new-form/index").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});
	import("./app/remote-dropdown-popup/index").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	import("./app/0 test-component/index").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	import("./app/custom-action-buttons/index").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	import("./old/TabGroupBlock/tab-groupblock").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	import("./sql/sql.js").then((app) => {
		// console.log("getting tickets", app);
		app.default();
	});

	// import("./old/report-organization-manager/report-organization-manager.js").then((mod) => {
	// 	mod.default();
	// });

	//src/special-design-ugrid/special-design-ugrid.js
	//src/special-action/special-action.js
}
